/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ConfirmAccountRouteImport } from "./routes/confirm-account"
import { Route as GuestRouteImport } from "./routes/_guest"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as GuestIndexRouteImport } from "./routes/_guest/index"
import { Route as InviteInviteIdRouteImport } from "./routes/invite/$inviteId"
import { Route as GuestTermsRouteImport } from "./routes/_guest/terms"
import { Route as GuestResetPasswordRouteImport } from "./routes/_guest/reset-password"
import { Route as GuestRegisterRouteImport } from "./routes/_guest/register"
import { Route as GuestPrivacyRouteImport } from "./routes/_guest/privacy"
import { Route as GuestMagicLinkRouteImport } from "./routes/_guest/magic-link"
import { Route as GuestForgotPasswordRouteImport } from "./routes/_guest/forgot-password"
import { Route as AuthenticatedSelectOrganizationRouteImport } from "./routes/_authenticated/select-organization"
import { Route as AuthenticatedProfileRouteImport } from "./routes/_authenticated/profile"
import { Route as AuthenticatedOnboardingRouteImport } from "./routes/_authenticated/onboarding"
import { Route as AuthenticatedInvitesRouteImport } from "./routes/_authenticated/invites"
import { Route as AuthenticatedHomeRouteImport } from "./routes/_authenticated/home"
import { Route as AuthenticatedOrgSlugRouteImport } from "./routes/_authenticated/$orgSlug"
import { Route as ChangelogServiceSlugIndexRouteImport } from "./routes/changelog/$serviceSlug/index"
import { Route as ChangelogUnsubscribeTokenRouteImport } from "./routes/changelog/unsubscribe.$token"
import { Route as ChangelogConfirmTokenRouteImport } from "./routes/changelog/confirm.$token"
import { Route as ChangelogServiceSlugEntrySlugRouteImport } from "./routes/changelog/$serviceSlug/$entrySlug"
import { Route as AuthCallbackEmailRouteImport } from "./routes/auth.callback.email"
import { Route as AuthenticatedOrgSlugSettingsRouteImport } from "./routes/_authenticated/$orgSlug/settings"
import { Route as AuthenticatedOrgSlugReportsRouteImport } from "./routes/_authenticated/$orgSlug/reports"
import { Route as AuthenticatedOrgSlugPeopleRouteImport } from "./routes/_authenticated/$orgSlug/people"
import { Route as AuthenticatedOrgSlugDashboardRouteImport } from "./routes/_authenticated/$orgSlug/dashboard"
import { Route as AuthenticatedOrgSlugSettingsIndexRouteImport } from "./routes/_authenticated/$orgSlug/settings/index"
import { Route as AuthenticatedOrgSlugPeopleIndexRouteImport } from "./routes/_authenticated/$orgSlug/people/index"
import { Route as AuthenticatedOrgSlugFinancesIndexRouteImport } from "./routes/_authenticated/$orgSlug/finances/index"
import { Route as AuthenticatedOrgSlugChangelogIndexRouteImport } from "./routes/_authenticated/$orgSlug/changelog/index"
import { Route as AuthenticatedOrgSlugSettingsMembersRouteImport } from "./routes/_authenticated/$orgSlug/settings/members"
import { Route as AuthenticatedOrgSlugSettingsFinanceRouteImport } from "./routes/_authenticated/$orgSlug/settings/finance"
import { Route as AuthenticatedOrgSlugSettingsApiKeysRouteImport } from "./routes/_authenticated/$orgSlug/settings/api-keys"
import { Route as AuthenticatedOrgSlugPeoplePersonIdRouteImport } from "./routes/_authenticated/$orgSlug/people/$personId"
import { Route as AuthenticatedOrgSlugSettingsFinanceCategoriesRouteImport } from "./routes/_authenticated/$orgSlug/settings/finance/categories"
import { Route as AuthenticatedOrgSlugSettingsFinanceAccountsRouteImport } from "./routes/_authenticated/$orgSlug/settings/finance/accounts"
import { Route as AuthenticatedOrgSlugChangelogServicesNewRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/new"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdIndexRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/index"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdTagsRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/tags"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/subscribers"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/entries/index"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/entries/new"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/entries/import"
import { Route as AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRouteImport } from "./routes/_authenticated/$orgSlug/changelog/services/$serviceId/entries/$entryId"

const ConfirmAccountRoute = ConfirmAccountRouteImport.update({
  id: "/confirm-account",
  path: "/confirm-account",
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: "/_guest",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const GuestIndexRoute = GuestIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => GuestRoute,
} as any)
const InviteInviteIdRoute = InviteInviteIdRouteImport.update({
  id: "/invite/$inviteId",
  path: "/invite/$inviteId",
  getParentRoute: () => rootRouteImport,
} as any)
const GuestTermsRoute = GuestTermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => GuestRoute,
} as any)
const GuestResetPasswordRoute = GuestResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => GuestRoute,
} as any)
const GuestRegisterRoute = GuestRegisterRouteImport.update({
  id: "/register",
  path: "/register",
  getParentRoute: () => GuestRoute,
} as any)
const GuestPrivacyRoute = GuestPrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => GuestRoute,
} as any)
const GuestMagicLinkRoute = GuestMagicLinkRouteImport.update({
  id: "/magic-link",
  path: "/magic-link",
  getParentRoute: () => GuestRoute,
} as any)
const GuestForgotPasswordRoute = GuestForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => GuestRoute,
} as any)
const AuthenticatedSelectOrganizationRoute =
  AuthenticatedSelectOrganizationRouteImport.update({
    id: "/select-organization",
    path: "/select-organization",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInvitesRoute = AuthenticatedInvitesRouteImport.update({
  id: "/invites",
  path: "/invites",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrgSlugRoute = AuthenticatedOrgSlugRouteImport.update({
  id: "/$orgSlug",
  path: "/$orgSlug",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ChangelogServiceSlugIndexRoute =
  ChangelogServiceSlugIndexRouteImport.update({
    id: "/changelog/$serviceSlug/",
    path: "/changelog/$serviceSlug/",
    getParentRoute: () => rootRouteImport,
  } as any)
const ChangelogUnsubscribeTokenRoute =
  ChangelogUnsubscribeTokenRouteImport.update({
    id: "/changelog/unsubscribe/$token",
    path: "/changelog/unsubscribe/$token",
    getParentRoute: () => rootRouteImport,
  } as any)
const ChangelogConfirmTokenRoute = ChangelogConfirmTokenRouteImport.update({
  id: "/changelog/confirm/$token",
  path: "/changelog/confirm/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogServiceSlugEntrySlugRoute =
  ChangelogServiceSlugEntrySlugRouteImport.update({
    id: "/changelog/$serviceSlug/$entrySlug",
    path: "/changelog/$serviceSlug/$entrySlug",
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthCallbackEmailRoute = AuthCallbackEmailRouteImport.update({
  id: "/auth/callback/email",
  path: "/auth/callback/email",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOrgSlugSettingsRoute =
  AuthenticatedOrgSlugSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugReportsRoute =
  AuthenticatedOrgSlugReportsRouteImport.update({
    id: "/reports",
    path: "/reports",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugPeopleRoute =
  AuthenticatedOrgSlugPeopleRouteImport.update({
    id: "/people",
    path: "/people",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugDashboardRoute =
  AuthenticatedOrgSlugDashboardRouteImport.update({
    id: "/dashboard",
    path: "/dashboard",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugSettingsIndexRoute =
  AuthenticatedOrgSlugSettingsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOrgSlugSettingsRoute,
  } as any)
const AuthenticatedOrgSlugPeopleIndexRoute =
  AuthenticatedOrgSlugPeopleIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedOrgSlugPeopleRoute,
  } as any)
const AuthenticatedOrgSlugFinancesIndexRoute =
  AuthenticatedOrgSlugFinancesIndexRouteImport.update({
    id: "/finances/",
    path: "/finances/",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogIndexRoute =
  AuthenticatedOrgSlugChangelogIndexRouteImport.update({
    id: "/changelog/",
    path: "/changelog/",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugSettingsMembersRoute =
  AuthenticatedOrgSlugSettingsMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthenticatedOrgSlugSettingsRoute,
  } as any)
const AuthenticatedOrgSlugSettingsFinanceRoute =
  AuthenticatedOrgSlugSettingsFinanceRouteImport.update({
    id: "/finance",
    path: "/finance",
    getParentRoute: () => AuthenticatedOrgSlugSettingsRoute,
  } as any)
const AuthenticatedOrgSlugSettingsApiKeysRoute =
  AuthenticatedOrgSlugSettingsApiKeysRouteImport.update({
    id: "/api-keys",
    path: "/api-keys",
    getParentRoute: () => AuthenticatedOrgSlugSettingsRoute,
  } as any)
const AuthenticatedOrgSlugPeoplePersonIdRoute =
  AuthenticatedOrgSlugPeoplePersonIdRouteImport.update({
    id: "/$personId",
    path: "/$personId",
    getParentRoute: () => AuthenticatedOrgSlugPeopleRoute,
  } as any)
const AuthenticatedOrgSlugSettingsFinanceCategoriesRoute =
  AuthenticatedOrgSlugSettingsFinanceCategoriesRouteImport.update({
    id: "/categories",
    path: "/categories",
    getParentRoute: () => AuthenticatedOrgSlugSettingsFinanceRoute,
  } as any)
const AuthenticatedOrgSlugSettingsFinanceAccountsRoute =
  AuthenticatedOrgSlugSettingsFinanceAccountsRouteImport.update({
    id: "/accounts",
    path: "/accounts",
    getParentRoute: () => AuthenticatedOrgSlugSettingsFinanceRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesNewRoute =
  AuthenticatedOrgSlugChangelogServicesNewRouteImport.update({
    id: "/changelog/services/new",
    path: "/changelog/services/new",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdIndexRouteImport.update({
    id: "/changelog/services/$serviceId/",
    path: "/changelog/services/$serviceId/",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdTagsRouteImport.update({
    id: "/changelog/services/$serviceId/tags",
    path: "/changelog/services/$serviceId/tags",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRouteImport.update({
    id: "/changelog/services/$serviceId/subscribers",
    path: "/changelog/services/$serviceId/subscribers",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRouteImport.update({
    id: "/changelog/services/$serviceId/entries/",
    path: "/changelog/services/$serviceId/entries/",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRouteImport.update({
    id: "/changelog/services/$serviceId/entries/new",
    path: "/changelog/services/$serviceId/entries/new",
    getParentRoute: () => AuthenticatedOrgSlugRoute,
  } as any)
const AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRouteImport.update(
    {
      id: "/changelog/services/$serviceId/entries/import",
      path: "/changelog/services/$serviceId/entries/import",
      getParentRoute: () => AuthenticatedOrgSlugRoute,
    } as any,
  )
const AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute =
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRouteImport.update(
    {
      id: "/changelog/services/$serviceId/entries/$entryId",
      path: "/changelog/services/$serviceId/entries/$entryId",
      getParentRoute: () => AuthenticatedOrgSlugRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  "/confirm-account": typeof ConfirmAccountRoute
  "/$orgSlug": typeof AuthenticatedOrgSlugRouteWithChildren
  "/home": typeof AuthenticatedHomeRoute
  "/invites": typeof AuthenticatedInvitesRoute
  "/onboarding": typeof AuthenticatedOnboardingRoute
  "/profile": typeof AuthenticatedProfileRoute
  "/select-organization": typeof AuthenticatedSelectOrganizationRoute
  "/forgot-password": typeof GuestForgotPasswordRoute
  "/magic-link": typeof GuestMagicLinkRoute
  "/privacy": typeof GuestPrivacyRoute
  "/register": typeof GuestRegisterRoute
  "/reset-password": typeof GuestResetPasswordRoute
  "/terms": typeof GuestTermsRoute
  "/invite/$inviteId": typeof InviteInviteIdRoute
  "/": typeof GuestIndexRoute
  "/$orgSlug/dashboard": typeof AuthenticatedOrgSlugDashboardRoute
  "/$orgSlug/people": typeof AuthenticatedOrgSlugPeopleRouteWithChildren
  "/$orgSlug/reports": typeof AuthenticatedOrgSlugReportsRoute
  "/$orgSlug/settings": typeof AuthenticatedOrgSlugSettingsRouteWithChildren
  "/auth/callback/email": typeof AuthCallbackEmailRoute
  "/changelog/$serviceSlug/$entrySlug": typeof ChangelogServiceSlugEntrySlugRoute
  "/changelog/confirm/$token": typeof ChangelogConfirmTokenRoute
  "/changelog/unsubscribe/$token": typeof ChangelogUnsubscribeTokenRoute
  "/changelog/$serviceSlug": typeof ChangelogServiceSlugIndexRoute
  "/$orgSlug/people/$personId": typeof AuthenticatedOrgSlugPeoplePersonIdRoute
  "/$orgSlug/settings/api-keys": typeof AuthenticatedOrgSlugSettingsApiKeysRoute
  "/$orgSlug/settings/finance": typeof AuthenticatedOrgSlugSettingsFinanceRouteWithChildren
  "/$orgSlug/settings/members": typeof AuthenticatedOrgSlugSettingsMembersRoute
  "/$orgSlug/changelog": typeof AuthenticatedOrgSlugChangelogIndexRoute
  "/$orgSlug/finances": typeof AuthenticatedOrgSlugFinancesIndexRoute
  "/$orgSlug/people/": typeof AuthenticatedOrgSlugPeopleIndexRoute
  "/$orgSlug/settings/": typeof AuthenticatedOrgSlugSettingsIndexRoute
  "/$orgSlug/changelog/services/new": typeof AuthenticatedOrgSlugChangelogServicesNewRoute
  "/$orgSlug/settings/finance/accounts": typeof AuthenticatedOrgSlugSettingsFinanceAccountsRoute
  "/$orgSlug/settings/finance/categories": typeof AuthenticatedOrgSlugSettingsFinanceCategoriesRoute
  "/$orgSlug/changelog/services/$serviceId/subscribers": typeof AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute
  "/$orgSlug/changelog/services/$serviceId/tags": typeof AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute
  "/$orgSlug/changelog/services/$serviceId": typeof AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute
  "/$orgSlug/changelog/services/$serviceId/entries/$entryId": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute
  "/$orgSlug/changelog/services/$serviceId/entries/import": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute
  "/$orgSlug/changelog/services/$serviceId/entries/new": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute
  "/$orgSlug/changelog/services/$serviceId/entries": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute
}
export interface FileRoutesByTo {
  "/confirm-account": typeof ConfirmAccountRoute
  "/$orgSlug": typeof AuthenticatedOrgSlugRouteWithChildren
  "/home": typeof AuthenticatedHomeRoute
  "/invites": typeof AuthenticatedInvitesRoute
  "/onboarding": typeof AuthenticatedOnboardingRoute
  "/profile": typeof AuthenticatedProfileRoute
  "/select-organization": typeof AuthenticatedSelectOrganizationRoute
  "/forgot-password": typeof GuestForgotPasswordRoute
  "/magic-link": typeof GuestMagicLinkRoute
  "/privacy": typeof GuestPrivacyRoute
  "/register": typeof GuestRegisterRoute
  "/reset-password": typeof GuestResetPasswordRoute
  "/terms": typeof GuestTermsRoute
  "/invite/$inviteId": typeof InviteInviteIdRoute
  "/": typeof GuestIndexRoute
  "/$orgSlug/dashboard": typeof AuthenticatedOrgSlugDashboardRoute
  "/$orgSlug/reports": typeof AuthenticatedOrgSlugReportsRoute
  "/auth/callback/email": typeof AuthCallbackEmailRoute
  "/changelog/$serviceSlug/$entrySlug": typeof ChangelogServiceSlugEntrySlugRoute
  "/changelog/confirm/$token": typeof ChangelogConfirmTokenRoute
  "/changelog/unsubscribe/$token": typeof ChangelogUnsubscribeTokenRoute
  "/changelog/$serviceSlug": typeof ChangelogServiceSlugIndexRoute
  "/$orgSlug/people/$personId": typeof AuthenticatedOrgSlugPeoplePersonIdRoute
  "/$orgSlug/settings/api-keys": typeof AuthenticatedOrgSlugSettingsApiKeysRoute
  "/$orgSlug/settings/finance": typeof AuthenticatedOrgSlugSettingsFinanceRouteWithChildren
  "/$orgSlug/settings/members": typeof AuthenticatedOrgSlugSettingsMembersRoute
  "/$orgSlug/changelog": typeof AuthenticatedOrgSlugChangelogIndexRoute
  "/$orgSlug/finances": typeof AuthenticatedOrgSlugFinancesIndexRoute
  "/$orgSlug/people": typeof AuthenticatedOrgSlugPeopleIndexRoute
  "/$orgSlug/settings": typeof AuthenticatedOrgSlugSettingsIndexRoute
  "/$orgSlug/changelog/services/new": typeof AuthenticatedOrgSlugChangelogServicesNewRoute
  "/$orgSlug/settings/finance/accounts": typeof AuthenticatedOrgSlugSettingsFinanceAccountsRoute
  "/$orgSlug/settings/finance/categories": typeof AuthenticatedOrgSlugSettingsFinanceCategoriesRoute
  "/$orgSlug/changelog/services/$serviceId/subscribers": typeof AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute
  "/$orgSlug/changelog/services/$serviceId/tags": typeof AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute
  "/$orgSlug/changelog/services/$serviceId": typeof AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute
  "/$orgSlug/changelog/services/$serviceId/entries/$entryId": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute
  "/$orgSlug/changelog/services/$serviceId/entries/import": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute
  "/$orgSlug/changelog/services/$serviceId/entries/new": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute
  "/$orgSlug/changelog/services/$serviceId/entries": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/_guest": typeof GuestRouteWithChildren
  "/confirm-account": typeof ConfirmAccountRoute
  "/_authenticated/$orgSlug": typeof AuthenticatedOrgSlugRouteWithChildren
  "/_authenticated/home": typeof AuthenticatedHomeRoute
  "/_authenticated/invites": typeof AuthenticatedInvitesRoute
  "/_authenticated/onboarding": typeof AuthenticatedOnboardingRoute
  "/_authenticated/profile": typeof AuthenticatedProfileRoute
  "/_authenticated/select-organization": typeof AuthenticatedSelectOrganizationRoute
  "/_guest/forgot-password": typeof GuestForgotPasswordRoute
  "/_guest/magic-link": typeof GuestMagicLinkRoute
  "/_guest/privacy": typeof GuestPrivacyRoute
  "/_guest/register": typeof GuestRegisterRoute
  "/_guest/reset-password": typeof GuestResetPasswordRoute
  "/_guest/terms": typeof GuestTermsRoute
  "/invite/$inviteId": typeof InviteInviteIdRoute
  "/_guest/": typeof GuestIndexRoute
  "/_authenticated/$orgSlug/dashboard": typeof AuthenticatedOrgSlugDashboardRoute
  "/_authenticated/$orgSlug/people": typeof AuthenticatedOrgSlugPeopleRouteWithChildren
  "/_authenticated/$orgSlug/reports": typeof AuthenticatedOrgSlugReportsRoute
  "/_authenticated/$orgSlug/settings": typeof AuthenticatedOrgSlugSettingsRouteWithChildren
  "/auth/callback/email": typeof AuthCallbackEmailRoute
  "/changelog/$serviceSlug/$entrySlug": typeof ChangelogServiceSlugEntrySlugRoute
  "/changelog/confirm/$token": typeof ChangelogConfirmTokenRoute
  "/changelog/unsubscribe/$token": typeof ChangelogUnsubscribeTokenRoute
  "/changelog/$serviceSlug/": typeof ChangelogServiceSlugIndexRoute
  "/_authenticated/$orgSlug/people/$personId": typeof AuthenticatedOrgSlugPeoplePersonIdRoute
  "/_authenticated/$orgSlug/settings/api-keys": typeof AuthenticatedOrgSlugSettingsApiKeysRoute
  "/_authenticated/$orgSlug/settings/finance": typeof AuthenticatedOrgSlugSettingsFinanceRouteWithChildren
  "/_authenticated/$orgSlug/settings/members": typeof AuthenticatedOrgSlugSettingsMembersRoute
  "/_authenticated/$orgSlug/changelog/": typeof AuthenticatedOrgSlugChangelogIndexRoute
  "/_authenticated/$orgSlug/finances/": typeof AuthenticatedOrgSlugFinancesIndexRoute
  "/_authenticated/$orgSlug/people/": typeof AuthenticatedOrgSlugPeopleIndexRoute
  "/_authenticated/$orgSlug/settings/": typeof AuthenticatedOrgSlugSettingsIndexRoute
  "/_authenticated/$orgSlug/changelog/services/new": typeof AuthenticatedOrgSlugChangelogServicesNewRoute
  "/_authenticated/$orgSlug/settings/finance/accounts": typeof AuthenticatedOrgSlugSettingsFinanceAccountsRoute
  "/_authenticated/$orgSlug/settings/finance/categories": typeof AuthenticatedOrgSlugSettingsFinanceCategoriesRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/subscribers": typeof AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/tags": typeof AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/": typeof AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/$entryId": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/import": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/new": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute
  "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/": typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/confirm-account"
    | "/$orgSlug"
    | "/home"
    | "/invites"
    | "/onboarding"
    | "/profile"
    | "/select-organization"
    | "/forgot-password"
    | "/magic-link"
    | "/privacy"
    | "/register"
    | "/reset-password"
    | "/terms"
    | "/invite/$inviteId"
    | "/"
    | "/$orgSlug/dashboard"
    | "/$orgSlug/people"
    | "/$orgSlug/reports"
    | "/$orgSlug/settings"
    | "/auth/callback/email"
    | "/changelog/$serviceSlug/$entrySlug"
    | "/changelog/confirm/$token"
    | "/changelog/unsubscribe/$token"
    | "/changelog/$serviceSlug"
    | "/$orgSlug/people/$personId"
    | "/$orgSlug/settings/api-keys"
    | "/$orgSlug/settings/finance"
    | "/$orgSlug/settings/members"
    | "/$orgSlug/changelog"
    | "/$orgSlug/finances"
    | "/$orgSlug/people/"
    | "/$orgSlug/settings/"
    | "/$orgSlug/changelog/services/new"
    | "/$orgSlug/settings/finance/accounts"
    | "/$orgSlug/settings/finance/categories"
    | "/$orgSlug/changelog/services/$serviceId/subscribers"
    | "/$orgSlug/changelog/services/$serviceId/tags"
    | "/$orgSlug/changelog/services/$serviceId"
    | "/$orgSlug/changelog/services/$serviceId/entries/$entryId"
    | "/$orgSlug/changelog/services/$serviceId/entries/import"
    | "/$orgSlug/changelog/services/$serviceId/entries/new"
    | "/$orgSlug/changelog/services/$serviceId/entries"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/confirm-account"
    | "/$orgSlug"
    | "/home"
    | "/invites"
    | "/onboarding"
    | "/profile"
    | "/select-organization"
    | "/forgot-password"
    | "/magic-link"
    | "/privacy"
    | "/register"
    | "/reset-password"
    | "/terms"
    | "/invite/$inviteId"
    | "/"
    | "/$orgSlug/dashboard"
    | "/$orgSlug/reports"
    | "/auth/callback/email"
    | "/changelog/$serviceSlug/$entrySlug"
    | "/changelog/confirm/$token"
    | "/changelog/unsubscribe/$token"
    | "/changelog/$serviceSlug"
    | "/$orgSlug/people/$personId"
    | "/$orgSlug/settings/api-keys"
    | "/$orgSlug/settings/finance"
    | "/$orgSlug/settings/members"
    | "/$orgSlug/changelog"
    | "/$orgSlug/finances"
    | "/$orgSlug/people"
    | "/$orgSlug/settings"
    | "/$orgSlug/changelog/services/new"
    | "/$orgSlug/settings/finance/accounts"
    | "/$orgSlug/settings/finance/categories"
    | "/$orgSlug/changelog/services/$serviceId/subscribers"
    | "/$orgSlug/changelog/services/$serviceId/tags"
    | "/$orgSlug/changelog/services/$serviceId"
    | "/$orgSlug/changelog/services/$serviceId/entries/$entryId"
    | "/$orgSlug/changelog/services/$serviceId/entries/import"
    | "/$orgSlug/changelog/services/$serviceId/entries/new"
    | "/$orgSlug/changelog/services/$serviceId/entries"
  id:
    | "__root__"
    | "/_authenticated"
    | "/_guest"
    | "/confirm-account"
    | "/_authenticated/$orgSlug"
    | "/_authenticated/home"
    | "/_authenticated/invites"
    | "/_authenticated/onboarding"
    | "/_authenticated/profile"
    | "/_authenticated/select-organization"
    | "/_guest/forgot-password"
    | "/_guest/magic-link"
    | "/_guest/privacy"
    | "/_guest/register"
    | "/_guest/reset-password"
    | "/_guest/terms"
    | "/invite/$inviteId"
    | "/_guest/"
    | "/_authenticated/$orgSlug/dashboard"
    | "/_authenticated/$orgSlug/people"
    | "/_authenticated/$orgSlug/reports"
    | "/_authenticated/$orgSlug/settings"
    | "/auth/callback/email"
    | "/changelog/$serviceSlug/$entrySlug"
    | "/changelog/confirm/$token"
    | "/changelog/unsubscribe/$token"
    | "/changelog/$serviceSlug/"
    | "/_authenticated/$orgSlug/people/$personId"
    | "/_authenticated/$orgSlug/settings/api-keys"
    | "/_authenticated/$orgSlug/settings/finance"
    | "/_authenticated/$orgSlug/settings/members"
    | "/_authenticated/$orgSlug/changelog/"
    | "/_authenticated/$orgSlug/finances/"
    | "/_authenticated/$orgSlug/people/"
    | "/_authenticated/$orgSlug/settings/"
    | "/_authenticated/$orgSlug/changelog/services/new"
    | "/_authenticated/$orgSlug/settings/finance/accounts"
    | "/_authenticated/$orgSlug/settings/finance/categories"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/subscribers"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/tags"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/$entryId"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/import"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/new"
    | "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  ConfirmAccountRoute: typeof ConfirmAccountRoute
  InviteInviteIdRoute: typeof InviteInviteIdRoute
  AuthCallbackEmailRoute: typeof AuthCallbackEmailRoute
  ChangelogServiceSlugEntrySlugRoute: typeof ChangelogServiceSlugEntrySlugRoute
  ChangelogConfirmTokenRoute: typeof ChangelogConfirmTokenRoute
  ChangelogUnsubscribeTokenRoute: typeof ChangelogUnsubscribeTokenRoute
  ChangelogServiceSlugIndexRoute: typeof ChangelogServiceSlugIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/confirm-account": {
      id: "/confirm-account"
      path: "/confirm-account"
      fullPath: "/confirm-account"
      preLoaderRoute: typeof ConfirmAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_guest": {
      id: "/_guest"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_guest/": {
      id: "/_guest/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof GuestIndexRouteImport
      parentRoute: typeof GuestRoute
    }
    "/invite/$inviteId": {
      id: "/invite/$inviteId"
      path: "/invite/$inviteId"
      fullPath: "/invite/$inviteId"
      preLoaderRoute: typeof InviteInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_guest/terms": {
      id: "/_guest/terms"
      path: "/terms"
      fullPath: "/terms"
      preLoaderRoute: typeof GuestTermsRouteImport
      parentRoute: typeof GuestRoute
    }
    "/_guest/reset-password": {
      id: "/_guest/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof GuestResetPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    "/_guest/register": {
      id: "/_guest/register"
      path: "/register"
      fullPath: "/register"
      preLoaderRoute: typeof GuestRegisterRouteImport
      parentRoute: typeof GuestRoute
    }
    "/_guest/privacy": {
      id: "/_guest/privacy"
      path: "/privacy"
      fullPath: "/privacy"
      preLoaderRoute: typeof GuestPrivacyRouteImport
      parentRoute: typeof GuestRoute
    }
    "/_guest/magic-link": {
      id: "/_guest/magic-link"
      path: "/magic-link"
      fullPath: "/magic-link"
      preLoaderRoute: typeof GuestMagicLinkRouteImport
      parentRoute: typeof GuestRoute
    }
    "/_guest/forgot-password": {
      id: "/_guest/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof GuestForgotPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    "/_authenticated/select-organization": {
      id: "/_authenticated/select-organization"
      path: "/select-organization"
      fullPath: "/select-organization"
      preLoaderRoute: typeof AuthenticatedSelectOrganizationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/profile": {
      id: "/_authenticated/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/onboarding": {
      id: "/_authenticated/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/invites": {
      id: "/_authenticated/invites"
      path: "/invites"
      fullPath: "/invites"
      preLoaderRoute: typeof AuthenticatedInvitesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/home": {
      id: "/_authenticated/home"
      path: "/home"
      fullPath: "/home"
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/$orgSlug": {
      id: "/_authenticated/$orgSlug"
      path: "/$orgSlug"
      fullPath: "/$orgSlug"
      preLoaderRoute: typeof AuthenticatedOrgSlugRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/changelog/$serviceSlug/": {
      id: "/changelog/$serviceSlug/"
      path: "/changelog/$serviceSlug"
      fullPath: "/changelog/$serviceSlug"
      preLoaderRoute: typeof ChangelogServiceSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/changelog/unsubscribe/$token": {
      id: "/changelog/unsubscribe/$token"
      path: "/changelog/unsubscribe/$token"
      fullPath: "/changelog/unsubscribe/$token"
      preLoaderRoute: typeof ChangelogUnsubscribeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/changelog/confirm/$token": {
      id: "/changelog/confirm/$token"
      path: "/changelog/confirm/$token"
      fullPath: "/changelog/confirm/$token"
      preLoaderRoute: typeof ChangelogConfirmTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/changelog/$serviceSlug/$entrySlug": {
      id: "/changelog/$serviceSlug/$entrySlug"
      path: "/changelog/$serviceSlug/$entrySlug"
      fullPath: "/changelog/$serviceSlug/$entrySlug"
      preLoaderRoute: typeof ChangelogServiceSlugEntrySlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback/email": {
      id: "/auth/callback/email"
      path: "/auth/callback/email"
      fullPath: "/auth/callback/email"
      preLoaderRoute: typeof AuthCallbackEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/$orgSlug/settings": {
      id: "/_authenticated/$orgSlug/settings"
      path: "/settings"
      fullPath: "/$orgSlug/settings"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/reports": {
      id: "/_authenticated/$orgSlug/reports"
      path: "/reports"
      fullPath: "/$orgSlug/reports"
      preLoaderRoute: typeof AuthenticatedOrgSlugReportsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/people": {
      id: "/_authenticated/$orgSlug/people"
      path: "/people"
      fullPath: "/$orgSlug/people"
      preLoaderRoute: typeof AuthenticatedOrgSlugPeopleRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/dashboard": {
      id: "/_authenticated/$orgSlug/dashboard"
      path: "/dashboard"
      fullPath: "/$orgSlug/dashboard"
      preLoaderRoute: typeof AuthenticatedOrgSlugDashboardRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/settings/": {
      id: "/_authenticated/$orgSlug/settings/"
      path: "/"
      fullPath: "/$orgSlug/settings/"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugSettingsRoute
    }
    "/_authenticated/$orgSlug/people/": {
      id: "/_authenticated/$orgSlug/people/"
      path: "/"
      fullPath: "/$orgSlug/people/"
      preLoaderRoute: typeof AuthenticatedOrgSlugPeopleIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugPeopleRoute
    }
    "/_authenticated/$orgSlug/finances/": {
      id: "/_authenticated/$orgSlug/finances/"
      path: "/finances"
      fullPath: "/$orgSlug/finances"
      preLoaderRoute: typeof AuthenticatedOrgSlugFinancesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/": {
      id: "/_authenticated/$orgSlug/changelog/"
      path: "/changelog"
      fullPath: "/$orgSlug/changelog"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/settings/members": {
      id: "/_authenticated/$orgSlug/settings/members"
      path: "/members"
      fullPath: "/$orgSlug/settings/members"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedOrgSlugSettingsRoute
    }
    "/_authenticated/$orgSlug/settings/finance": {
      id: "/_authenticated/$orgSlug/settings/finance"
      path: "/finance"
      fullPath: "/$orgSlug/settings/finance"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsFinanceRouteImport
      parentRoute: typeof AuthenticatedOrgSlugSettingsRoute
    }
    "/_authenticated/$orgSlug/settings/api-keys": {
      id: "/_authenticated/$orgSlug/settings/api-keys"
      path: "/api-keys"
      fullPath: "/$orgSlug/settings/api-keys"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsApiKeysRouteImport
      parentRoute: typeof AuthenticatedOrgSlugSettingsRoute
    }
    "/_authenticated/$orgSlug/people/$personId": {
      id: "/_authenticated/$orgSlug/people/$personId"
      path: "/$personId"
      fullPath: "/$orgSlug/people/$personId"
      preLoaderRoute: typeof AuthenticatedOrgSlugPeoplePersonIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugPeopleRoute
    }
    "/_authenticated/$orgSlug/settings/finance/categories": {
      id: "/_authenticated/$orgSlug/settings/finance/categories"
      path: "/categories"
      fullPath: "/$orgSlug/settings/finance/categories"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsFinanceCategoriesRouteImport
      parentRoute: typeof AuthenticatedOrgSlugSettingsFinanceRoute
    }
    "/_authenticated/$orgSlug/settings/finance/accounts": {
      id: "/_authenticated/$orgSlug/settings/finance/accounts"
      path: "/accounts"
      fullPath: "/$orgSlug/settings/finance/accounts"
      preLoaderRoute: typeof AuthenticatedOrgSlugSettingsFinanceAccountsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugSettingsFinanceRoute
    }
    "/_authenticated/$orgSlug/changelog/services/new": {
      id: "/_authenticated/$orgSlug/changelog/services/new"
      path: "/changelog/services/new"
      fullPath: "/$orgSlug/changelog/services/new"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesNewRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/"
      path: "/changelog/services/$serviceId"
      fullPath: "/$orgSlug/changelog/services/$serviceId"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/tags": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/tags"
      path: "/changelog/services/$serviceId/tags"
      fullPath: "/$orgSlug/changelog/services/$serviceId/tags"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdTagsRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/subscribers": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/subscribers"
      path: "/changelog/services/$serviceId/subscribers"
      fullPath: "/$orgSlug/changelog/services/$serviceId/subscribers"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/"
      path: "/changelog/services/$serviceId/entries"
      fullPath: "/$orgSlug/changelog/services/$serviceId/entries"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/new": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/new"
      path: "/changelog/services/$serviceId/entries/new"
      fullPath: "/$orgSlug/changelog/services/$serviceId/entries/new"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/import": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/import"
      path: "/changelog/services/$serviceId/entries/import"
      fullPath: "/$orgSlug/changelog/services/$serviceId/entries/import"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
    "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/$entryId": {
      id: "/_authenticated/$orgSlug/changelog/services/$serviceId/entries/$entryId"
      path: "/changelog/services/$serviceId/entries/$entryId"
      fullPath: "/$orgSlug/changelog/services/$serviceId/entries/$entryId"
      preLoaderRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRouteImport
      parentRoute: typeof AuthenticatedOrgSlugRoute
    }
  }
}

interface AuthenticatedOrgSlugPeopleRouteChildren {
  AuthenticatedOrgSlugPeoplePersonIdRoute: typeof AuthenticatedOrgSlugPeoplePersonIdRoute
  AuthenticatedOrgSlugPeopleIndexRoute: typeof AuthenticatedOrgSlugPeopleIndexRoute
}

const AuthenticatedOrgSlugPeopleRouteChildren: AuthenticatedOrgSlugPeopleRouteChildren =
  {
    AuthenticatedOrgSlugPeoplePersonIdRoute:
      AuthenticatedOrgSlugPeoplePersonIdRoute,
    AuthenticatedOrgSlugPeopleIndexRoute: AuthenticatedOrgSlugPeopleIndexRoute,
  }

const AuthenticatedOrgSlugPeopleRouteWithChildren =
  AuthenticatedOrgSlugPeopleRoute._addFileChildren(
    AuthenticatedOrgSlugPeopleRouteChildren,
  )

interface AuthenticatedOrgSlugSettingsFinanceRouteChildren {
  AuthenticatedOrgSlugSettingsFinanceAccountsRoute: typeof AuthenticatedOrgSlugSettingsFinanceAccountsRoute
  AuthenticatedOrgSlugSettingsFinanceCategoriesRoute: typeof AuthenticatedOrgSlugSettingsFinanceCategoriesRoute
}

const AuthenticatedOrgSlugSettingsFinanceRouteChildren: AuthenticatedOrgSlugSettingsFinanceRouteChildren =
  {
    AuthenticatedOrgSlugSettingsFinanceAccountsRoute:
      AuthenticatedOrgSlugSettingsFinanceAccountsRoute,
    AuthenticatedOrgSlugSettingsFinanceCategoriesRoute:
      AuthenticatedOrgSlugSettingsFinanceCategoriesRoute,
  }

const AuthenticatedOrgSlugSettingsFinanceRouteWithChildren =
  AuthenticatedOrgSlugSettingsFinanceRoute._addFileChildren(
    AuthenticatedOrgSlugSettingsFinanceRouteChildren,
  )

interface AuthenticatedOrgSlugSettingsRouteChildren {
  AuthenticatedOrgSlugSettingsApiKeysRoute: typeof AuthenticatedOrgSlugSettingsApiKeysRoute
  AuthenticatedOrgSlugSettingsFinanceRoute: typeof AuthenticatedOrgSlugSettingsFinanceRouteWithChildren
  AuthenticatedOrgSlugSettingsMembersRoute: typeof AuthenticatedOrgSlugSettingsMembersRoute
  AuthenticatedOrgSlugSettingsIndexRoute: typeof AuthenticatedOrgSlugSettingsIndexRoute
}

const AuthenticatedOrgSlugSettingsRouteChildren: AuthenticatedOrgSlugSettingsRouteChildren =
  {
    AuthenticatedOrgSlugSettingsApiKeysRoute:
      AuthenticatedOrgSlugSettingsApiKeysRoute,
    AuthenticatedOrgSlugSettingsFinanceRoute:
      AuthenticatedOrgSlugSettingsFinanceRouteWithChildren,
    AuthenticatedOrgSlugSettingsMembersRoute:
      AuthenticatedOrgSlugSettingsMembersRoute,
    AuthenticatedOrgSlugSettingsIndexRoute:
      AuthenticatedOrgSlugSettingsIndexRoute,
  }

const AuthenticatedOrgSlugSettingsRouteWithChildren =
  AuthenticatedOrgSlugSettingsRoute._addFileChildren(
    AuthenticatedOrgSlugSettingsRouteChildren,
  )

interface AuthenticatedOrgSlugRouteChildren {
  AuthenticatedOrgSlugDashboardRoute: typeof AuthenticatedOrgSlugDashboardRoute
  AuthenticatedOrgSlugPeopleRoute: typeof AuthenticatedOrgSlugPeopleRouteWithChildren
  AuthenticatedOrgSlugReportsRoute: typeof AuthenticatedOrgSlugReportsRoute
  AuthenticatedOrgSlugSettingsRoute: typeof AuthenticatedOrgSlugSettingsRouteWithChildren
  AuthenticatedOrgSlugChangelogIndexRoute: typeof AuthenticatedOrgSlugChangelogIndexRoute
  AuthenticatedOrgSlugFinancesIndexRoute: typeof AuthenticatedOrgSlugFinancesIndexRoute
  AuthenticatedOrgSlugChangelogServicesNewRoute: typeof AuthenticatedOrgSlugChangelogServicesNewRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute: typeof AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute
}

const AuthenticatedOrgSlugRouteChildren: AuthenticatedOrgSlugRouteChildren = {
  AuthenticatedOrgSlugDashboardRoute: AuthenticatedOrgSlugDashboardRoute,
  AuthenticatedOrgSlugPeopleRoute: AuthenticatedOrgSlugPeopleRouteWithChildren,
  AuthenticatedOrgSlugReportsRoute: AuthenticatedOrgSlugReportsRoute,
  AuthenticatedOrgSlugSettingsRoute:
    AuthenticatedOrgSlugSettingsRouteWithChildren,
  AuthenticatedOrgSlugChangelogIndexRoute:
    AuthenticatedOrgSlugChangelogIndexRoute,
  AuthenticatedOrgSlugFinancesIndexRoute:
    AuthenticatedOrgSlugFinancesIndexRoute,
  AuthenticatedOrgSlugChangelogServicesNewRoute:
    AuthenticatedOrgSlugChangelogServicesNewRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdSubscribersRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdTagsRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdIndexRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdEntriesEntryIdRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdEntriesImportRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdEntriesNewRoute,
  AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute:
    AuthenticatedOrgSlugChangelogServicesServiceIdEntriesIndexRoute,
}

const AuthenticatedOrgSlugRouteWithChildren =
  AuthenticatedOrgSlugRoute._addFileChildren(AuthenticatedOrgSlugRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedOrgSlugRoute: typeof AuthenticatedOrgSlugRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedInvitesRoute: typeof AuthenticatedInvitesRoute
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSelectOrganizationRoute: typeof AuthenticatedSelectOrganizationRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedOrgSlugRoute: AuthenticatedOrgSlugRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedInvitesRoute: AuthenticatedInvitesRoute,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSelectOrganizationRoute: AuthenticatedSelectOrganizationRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface GuestRouteChildren {
  GuestForgotPasswordRoute: typeof GuestForgotPasswordRoute
  GuestMagicLinkRoute: typeof GuestMagicLinkRoute
  GuestPrivacyRoute: typeof GuestPrivacyRoute
  GuestRegisterRoute: typeof GuestRegisterRoute
  GuestResetPasswordRoute: typeof GuestResetPasswordRoute
  GuestTermsRoute: typeof GuestTermsRoute
  GuestIndexRoute: typeof GuestIndexRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestForgotPasswordRoute: GuestForgotPasswordRoute,
  GuestMagicLinkRoute: GuestMagicLinkRoute,
  GuestPrivacyRoute: GuestPrivacyRoute,
  GuestRegisterRoute: GuestRegisterRoute,
  GuestResetPasswordRoute: GuestResetPasswordRoute,
  GuestTermsRoute: GuestTermsRoute,
  GuestIndexRoute: GuestIndexRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  ConfirmAccountRoute: ConfirmAccountRoute,
  InviteInviteIdRoute: InviteInviteIdRoute,
  AuthCallbackEmailRoute: AuthCallbackEmailRoute,
  ChangelogServiceSlugEntrySlugRoute: ChangelogServiceSlugEntrySlugRoute,
  ChangelogConfirmTokenRoute: ChangelogConfirmTokenRoute,
  ChangelogUnsubscribeTokenRoute: ChangelogUnsubscribeTokenRoute,
  ChangelogServiceSlugIndexRoute: ChangelogServiceSlugIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
